import { $ } from '@/libs/jquery/index'
import { routes } from '@/libs/routes/index'

interface IRemoveInteractionsOption {
  button: JQuery
  leadID: number
}

export class DigitalSignatureRemoveInteractions {

  public button: JQuery
  public leadID: number

  constructor(options: IRemoveInteractionsOption) {
    this.button = options.button
    this.leadID = options.leadID

    this.init()
  }

  public init(): void {
    this.button
      .off('click', () => this.removeInteractions())
      .on('click', () => this.removeInteractions())
  }

  public hideButton(): void {
    this.button.addClass('hidden')
  }

  public showButton(): void {
    this.button.removeClass('hidden')
  }

  private removeInteractions(): void {
    const url = routes.crm_verification_center_uc_request_path(this.leadID)

    $
      .ajax({ method: 'delete', url })
      .done(() => window.location.reload())
  }
}
